var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6264_4034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5C9.86193 13.5 9.75 13.3881 9.75 13.25C9.75 13.1119 9.86193 13 10 13",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5C10.1381 13.5 10.25 13.3881 10.25 13.25C10.25 13.1119 10.1381 13 10 13",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2495 15.5005C10.8463 15.5005 11.4185 15.2634 11.8405 14.8415C12.2625 14.4195 12.4995 13.8472 12.4995 13.2505C12.4995 12.6538 12.2625 12.0814 11.8405 11.6595C11.4185 11.2376 10.8463 11.0005 10.2495 11.0005H4.74951C4.15278 11.0005 3.58048 11.2376 3.15853 11.6595C2.73657 12.0814 2.49951 12.6538 2.49951 13.2505C2.49951 13.8472 2.73657 14.4195 3.15853 14.8415C3.58048 15.2634 4.15278 15.5005 4.74951 15.5005H10.2495Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3262 12.3847L11.0122 9.23133C10.8604 8.8668 10.6041 8.55533 10.2756 8.3362C9.94712 8.11707 9.56105 8.00007 9.16618 8H5.83285C5.43796 8.00007 5.05194 8.11707 4.72342 8.3362C4.39491 8.55533 4.13863 8.8668 3.98685 9.23133L2.67285 12.3847",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9266 10.0434C14.2991 9.8192 14.6229 9.5226 14.8787 9.171C15.1344 8.8194 15.317 8.42 15.4155 7.99653C15.5141 7.57307 15.5265 7.13413 15.4523 6.70573C15.378 6.27737 15.2185 5.86826 14.9831 5.50269C14.7477 5.13711 14.4414 4.82251 14.0822 4.57755C13.723 4.33258 13.3183 4.16223 12.892 4.0766C12.4657 3.99097 12.0267 3.99181 11.6007 4.07905C11.1748 4.1663 10.7707 4.33818 10.4125 4.58451C10.2711 3.82461 9.95553 3.10783 9.4904 2.49051C9.02527 1.8732 8.42333 1.37216 7.73187 1.02678C7.0404 0.681394 6.27823 0.501081 5.5053 0.500005C4.73237 0.498929 3.96973 0.67712 3.2773 1.02057C2.58487 1.36403 1.98153 1.86339 1.51469 2.47941C1.04785 3.09543 0.73024 3.81133 0.586811 4.57083C0.443383 5.33033 0.478049 6.11275 0.688087 6.8566C0.89812 7.60047 1.27781 8.28547 1.79729 8.85773",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6264_4034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackends);
export default __webpack_public_path__ + "static/media/backends.300dc588.svg";
export { ForwardRef as ReactComponent };